import { Pipe, PipeTransform, inject } from '@angular/core';

import { Me } from 'src/providers/me/me';

@Pipe({ name: 'subscriptionType', standalone: true, pure: true })
export class SubscriptionTypePipe implements PipeTransform {
  private me = inject(Me);

  transform(subscriptionKey: string): string {
    return this.me.getSubscriptionType(subscriptionKey);
  }
}
